import React, {Component} from 'react';
import _ from 'lodash';

import {topoUtils} from '../utils/topo-utils';
import mapboxgl from 'mapbox-gl/dist/mapbox-gl';
import './MapboxLight.css';

class Mapbox extends Component {

  componentDidMount() {
    const self = this;

    mapboxgl.accessToken = 'pk.eyJ1IjoidG9ueXBhdHRvbjciLCJhIjoiY2o2dXpncXh2MHM3aDJxbnpqdDRqejl0ZCJ9.GU0cdI-4Rk8VeWBVFKLynQ';

    const map = new mapboxgl.Map({
      container: this.container,
      style: 'mapbox://styles/tonypatton7/cj6wmccyo97222snylll2ota3',
      scrollZoom: false,
      boxZoom: false,
      attributionControl: false,
      refreshExpiredTiles: false,
      dragRotate: true,
      keyboard: false,
      dragPan: this.container.offsetWidth > 992,
      center: [-98, 38.88],
      minZoom: 2,
      zoom: 3
    });

    // Disable default box zooming.
    map.boxZoom.disable();

    map.addControl(new mapboxgl.NavigationControl({}), 'top-right');

    map.addControl(new mapboxgl.AttributionControl({
      compact: true
    }));

    map.on('load', function () {

      map.addSource('counties', {
        "type": "vector",
        "url": "mapbox://mapbox.82pkq93d"
      });

      map.addLayer({
        "id": "counties-highlighted",
        "type": "fill",
        "source": "counties",
        "source-layer": "original",
        "paint": {
          "fill-outline-color": "rgba(100,172,190,1)",
          "fill-color": "rgba(100,172,190,.1)",
        },
        "filter": ["in", "FIPS", ""]
      });

      map.addSource('providers', {
        type: 'geojson', data: {
          "type": "FeatureCollection",
          "features": []
        }
      });

      map.addLayer({
        "id": "provider-points",
        "type": "circle",
        "source": "providers",
        "paint": {
          'circle-color': '#3bb2d0'
        }
      });

      map.on('click', function (e) {
        const features = map.queryRenderedFeatures(e.point, {
          layers: ['drug-treatment', 'provider-points']
        });

        if (!features.length) {
          return;
        }

        let content = '';
        const feature = features[0];

        if (feature.layer.id === 'provider-points') {
          content = `<h3>${feature.properties.name}</h3>` +
            `<p>${feature.properties.specialty}<br/>NPI: ${feature.properties.npi}</p>` +
            `<p><b>Opioid Patient Percent : </b><i>${feature.properties.opioidBenePct}</i><br/>` +
            `<b>Opioid Claims per Patient : </b><i>${feature.properties.opioidClaimsPm}</i><br/>` +
            `<b>Opioid Day Supply / Patient : </b><i>${feature.properties.opioidDaySupplyPm}</i></p>`
          ;
        }
        else {
          content = `<h3>${feature.properties.name}</h3><p>${feature.properties.street}<br/>` +
            `${feature.properties.city}, ${feature.properties.state} ${feature.properties.zip}</p>` +
            `<p><a href="tel:${_.camelCase(feature.properties.phone)}">${feature.properties.phone}</a></p>`;
        }

        new mapboxgl.Popup({closeButton: false})
          .setLngLat(feature.geometry.coordinates)
          .setHTML(content)
          .setLngLat(feature.geometry.coordinates)
          .addTo(map);
      });

      map.on('moveend', () => {
        if (self.props.features && self.props.features.length) {
          const features = _.chain(self.props.features)
            .filter(d => d.lat && d.lng)
            .map(d => {
              return {
                "type": "Feature",
                "geometry": {
                  "type": "Point",
                  "coordinates": [d.lng, d.lat]
                },
                "properties": {...d}
              }
            })
            .value();

          if (features && features.length) {
            map.getSource('providers').setData({
              "type": "FeatureCollection",
              "features": features
            });
          }
        }
      });

      self.updateMap(false);
    });

    self.map = map;
  }

  updateMap(prevProps, animated) {
    const map = this.map;
    const props = this.props;

    let fips = props.countyFips;
    if (fips && fips !== prevProps.countyFips) {

      if (fips < 9999) {
        fips = '0' + fips;
      }

      map.setFilter("counties-highlighted", ['==', 'FIPS', fips]);

      setTimeout(function () {
        const topo = topoUtils.getCountyTopography(props.countyFips);
        const mapBounds = [[topo.bounds[0], topo.bounds[1]], [topo.bounds[2], topo.bounds[3]]];
        const boundConfig = {padding: {top: 20, bottom: 20, right: 20, left: 20}, animate: animated};

        map.fitBounds(mapBounds, boundConfig);
      }, 100);
    }
  }

  componentDidUpdate(prevProps) {
    const self = this;
    if (self.map.loaded()) {
      self.updateMap(prevProps, true);
    }
    else {
      self.map.on('load', function () {
        self.updateMap(prevProps, false);
      })
    }
  }

  render() {
    return (
      <div className="MapboxLight" ref={x => this.container = x}></div>
    );
  }
}

export default Mapbox;



// WEBPACK FOOTER //
// ./src/charts/Mapbox/index.js